import { Avatar } from '@mui/material'

export default function ContainedAvatar({
  src,
  sx,
  alt,
  variant
}: {
  src: string
  sx?: any
  alt?: string
  variant?: 'circular' | 'rounded' | 'square'
}) {
  return (
    <Avatar
      src={src}
      {...(sx ? { sx } : {})}
      {...(alt ? { alt } : {})}
      variant={variant}
      slotProps={{
        img: {
          style: {
            objectFit: 'contain',
            width: '100%',
            height: '100%'
          }
        }
      }}
    />
  )
}
